
import React from "react";
import { Box, Typography } from "@mui/material";

const DonationLabelPreview = ({ data = {}, donorData = {} }) => {
  if (!data || Object.keys(data).length === 0)
    return (
      <Typography variant="body2" sx={{ mt: 2, color: "gray" }}>
        Fill donation form to preview label here.
      </Typography>
    );

  const leftLines = [];
  const rightLines = [];

  // Left column: ID, name, address, city (keeps existing left alignment)
  if (data?.donorId) leftLines.push(`#${data?.donorId}`);
  const nameToShow = data?.tributeName
    ? data?.tributeName
    : `${donorData?.salutation || ""} ${donorData?.initial || ""} ${data?.firstName || ""} ${data?.lastName || ""}`.trim();
  leftLines.push(nameToShow);
  if (donorData?.address) leftLines.push(donorData?.address);
  if (donorData?.address1) leftLines.push(donorData?.address1);
  if (donorData?.address2) leftLines.push(donorData?.address2);
  if (data?.city || donorData?.pincode) leftLines.push(`${data?.city || ""} ${donorData?.pincode || ""}`.trim());
  
  // Mobile Number with validation - Use donor's mobile numbers
  let mobile1 = data?.mobile1 ? String(data?.mobile1).trim() : "";
  let mobile2 = donorData?.mobile2 ? String(donorData?.mobile2).trim() : "";
  const countryCode = donorData?.countryCode || "91";
  
  // Strip country code prefix safely - only remove the actual country code, not part of the number
  // const stripCountryCode = (num) => {
  //   if (!num) return "";
  //   if (num.startsWith(`+${countryCode}`)) {
  //     return num.slice((`+${countryCode}`).length).trim();
  //   } else if (num.startsWith(countryCode)) {
  //     return num.slice(countryCode.length).trim();
  //   }
  //   return num;
  // };
    const stripCountryCode = (num) => {
  if (!num) return "";

  let cleaned = num.replace(/\s+/g, "").trim();

  // Remove +91
  if (cleaned.startsWith(`+${countryCode}`)) {
    return cleaned.substring(countryCode.length + 1);
  }

  // Remove 91 only if number length > 10
  if (cleaned.startsWith(countryCode) && cleaned.length > 10) {
    return cleaned.substring(countryCode.length);
  }

  return cleaned;
};
  mobile1 = stripCountryCode(mobile1);
  mobile2 = stripCountryCode(mobile2);
  
  // Only show if has valid digits (more than 3)
  const hasMobile1 = mobile1 && mobile1.replace(/\D/g, '').length > 3;
  const hasMobile2 = mobile2 && mobile2.replace(/\D/g, '').length > 3;
  
  if (hasMobile1 || hasMobile2) {
    const mobileText = [];
    if (hasMobile1) mobileText.push(mobile1);
    if (hasMobile2) mobileText.push(mobile2);
    // Format: "Mob: XXXXXXXXXX YYYYYYYYYY" (only last 10 digits, space separator)
    leftLines.push(`Mob: ${mobileText.join(",")}`);
  }

  // Right column composition with conditional logic:
  // Line 1: sharma (only if present)
  if (data?.sharma) {
    rightLines.push(data?.sharma);
  }

  // Line 2: conditional fallback priority
  // Priority 1: tamilMonth + star (nachathiram) if both present
  if (data?.tamilMonths && data?.nachathiram) {
    rightLines.push([data?.tamilMonths, data?.nachathiram].join(" "));
  }
  // Priority 2: tamilMonth + thithi (if star/nachathiram is missing)
  else if (data?.tamilMonths && data?.thithi) {
    rightLines.push([data?.tamilMonths, data?.thithi].join(" "));
  }
  // Priority 3: thithi alone (if tamilMonth missing)
  else if (data?.thithi) {
    rightLines.push(data?.thithi);
  }
  // Priority 4: tamilMonth alone (if thithi missing)
  else if (data?.tamilMonths) {
    rightLines.push(data?.tamilMonths);
  }
  // Priority 5: utsavam (if all above missing)
  else if (data?.utsavam) {
    rightLines.push(data?.utsavam);
  }
  // Priority 6: poojaDate (fallback if all above missing)
  else if (data?.poojaDate) {
    rightLines.push(data?.poojaDate);
  }

  // Line 4: City

  return (
    <>
      <Box
        sx={{
          border: "1px solid #ccc",
          padding: 2,
          borderRadius: 2,
          fontFamily: "NotoSansTamil, sans-serif",
          fontSize: "13px",
          backgroundColor: "#fafafa",
          minHeight: "auto",
        }}
      >
        <Box
          sx={{
            borderRadius: 1,
            minHeight: "auto",
            padding: "6px",
            overflow: "visible",
          }}
        >
          {/* Left column stacked first (ID, name, address, mobile) */}
          <Box>
            {leftLines.map((line, idx) => (
              <Typography key={`L${idx}`} sx={{ fontSize: "13px", lineHeight: "1.2", textAlign: "left" }}>
                {line}
              </Typography>
            ))}
          </Box>

          {/* Right-aligned block stacked below the left block (appears after mobile) */}
          {rightLines.length > 0 && (
            <Box sx={{ mt: 1, display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
              {rightLines.map((line, idx) => (
                <Typography key={`R${idx}`} sx={{ fontSize: "13px", lineHeight: "1.2", textAlign: "right" }}>
                  {line}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default DonationLabelPreview;
